// extracted by mini-css-extract-plugin
module.exports = {"svg":"Loader_svg__36Kfr","container_full":"Loader_container_full__3aY-k","container_bg":"Loader_container_bg__iN_S_"};